import React, { useState } from "react";
import useSWR from "swr";
import { openNotification } from "../../common/elements/myNotification";
import { deleteHospitalDischarge } from "../../api/CareEventSCPApi";
import { fetcherhn } from "../../services/fectcher";
import {
  Button,
  Drawer,
  Popconfirm,
  Skeleton,
  Space,
  Table,
  Tooltip,
} from "antd";
import Search from "antd/es/input/Search";
import { WarningOutlined } from "@ant-design/icons";
import CareHospitalDischargeAdd from "./CareHospitalDischargeAdd";
import { handleToggle } from "../../common/elements/toggleSeeMore";
import { useMyContext } from "../../common/elements/myContext";
import { FaEdit, FaMobileAlt, FaRegTrashAlt } from "react-icons/fa";
import { FiSend } from "react-icons/fi";
import SendEmail from "../../common/elements/SendEmail";

const CareHospitalDischarge = (props) => {
  const initialReqState = {
    key: "",
    guid: "",
    mbi: props.mbiid,
    hospitalName: "",
    hospitalTelephone: "",
    hospitalAdmissionDate: "",
    hospitalDischargeDate: "",
    hospitalDischargeDx: "",
    locationDischargedTo: "",
    dischargeInstructions: "",
    medxNotes: "",
    createdBy: sessionStorage.getItem("userName"),
    modifiedBy: "",
  };

  const [editRecord, setEditRecord] = useState(initialReqState);
  const [query, setQuery] = useState("");
  const { formatPhoneNumber } = useMyContext();

  const [isModalOpen, setIsModalOpen] = useState(false);

  const { data, mutate, isLoading } = useSWR(
    `GetHospitalDischargeTemplate?id=${props.mbiid}`,
    fetcherhn
  );

  const handleCancel = (e) => {
    setIsModalOpen(false);
    setEditRecord(initialReqState);
  };

  const handleModalClose = (e) => {
    setEditRecord(initialReqState);
    setMail(false);
  };

  const [mail, setMail] = useState(false);

  const sendDatatoEmail = (record) => {
    setMail(true);
    setEditRecord(record);
  };

  const handleOk = async (e) => {
    if (e) {
      mutate();
    }
    setIsModalOpen(false);
    setEditRecord(initialReqState);
  };

  const edit = (record) => {
    setIsModalOpen(true);
    setEditRecord(record);
  };

  const handleDelete = async (record) => {
    const body = {
      ...record,
      modifiedBy: sessionStorage.getItem("userName"),
    };
    const deleteResult = await deleteHospitalDischarge(body);
    if (deleteResult.status) {
      mutate();
      openNotification(
        "success",
        "Deleted",
        "Hospital Discharge Template Deleted Successfully!"
      );
    }
    setEditRecord(initialReqState);
  };

  const [expandedRows, setExpandedRows] = useState([]);

  const columns = [
    {
      key: 1,
      title: "Hospital Name/Telephone#",
      dataIndex: "hospitalName",
      render: (_, { hospitalName, hospitalTelephone }) => (
        <>
          <div>{hospitalName}</div>
          {hospitalTelephone ? (
            <div
              style={{
                fontSize: "0.9rem",
                color: "var(--bs-gray-600)",
                marginBottom: "0.3rem",
                marginTop: "0.3rem",
                overflowWrap: "break-word",
              }}
            >
              <FaMobileAlt
                size={20}
                style={{
                  color: "var(--bs-gray-500)",
                  marginRight: "0.5rem",
                  marginTop: "-2px",
                }}
              />
              <a href={`tel:${formatPhoneNumber(hospitalTelephone)}`}>
                {formatPhoneNumber(hospitalTelephone)}
              </a>
            </div>
          ) : (
            ""
          )}
        </>
      ),
    },
    // {
    //   key: 2,
    //   title: "Hospital Telephone#",
    //   dataIndex: "hospitalTelephone",
    // },
    {
      key: 3,
      title: "Hospital Admission Date",
      dataIndex: "hospitalAdmissionDate",
    },
    {
      key: 4,
      title: "Hospital Discharge Date",
      dataIndex: "hospitalDischargeDate",
    },
    {
      key: 5,
      title: "Hospital Discharge Dx",
      dataIndex: "hospitalDischargeDx",
    },
    {
      key: 7,
      title: "Location Discharged To",
      dataIndex: "locationDischargedTo",
    },
    {
      key: 8,
      title: "Discharge Instructions",
      dataIndex: "dischargeInstructions",
    },
    {
      key: 9,
      title: "MedEx Notes / Message",
      dataIndex: "medxNotes",
      width: 400,
      render: (text, record) => {
        const isExpanded = expandedRows.includes(record.key);
        const content =
          text.length > 100 ? (
            <span>
              {isExpanded ? text : `${text.substring(0, 100)}...`}
              <Button
                type="link"
                onClick={() => handleToggle(record.key, setExpandedRows)}
              >
                {isExpanded ? "See less" : "See more"}
              </Button>
            </span>
          ) : (
            text
          );

        return <div>{content}</div>;
      },
    },
    {
      key: 10,
      title: "Created By",
      dataIndex: "createdBy",
      render: (createdBy) => <div>{createdBy.split("@")[0]}</div>,
    },
    {
      key: "key",
      title: "Operation",
      dataIndex: "guid",
      fixed: "right",
      width: 110,
      render: (_, record) => (
        <div>
          <Space>
            <Tooltip title="Edit">
              <FaEdit
                size={20}
                className=" tw-cursor-pointer"
                onClick={() => edit(record)}
                color="blue"
              />
            </Tooltip>
            <Tooltip title="Delete">
              <Popconfirm
                title="Ok to Delete?"
                onConfirm={() => handleDelete(record)}
                icon={
                  <WarningOutlined
                    style={{
                      color: "red",
                    }}
                  />
                }
              >
                <FaRegTrashAlt
                  size={20}
                  className=" tw-cursor-pointer"
                  color="red"
                />
              </Popconfirm>
            </Tooltip>
            <Tooltip title="Send Email">
              <FiSend
                size={20}
                className=" tw-cursor-pointer"
                onClick={() => sendDatatoEmail(record)}
                color="green"
              />
            </Tooltip>
          </Space>
        </div>
      ),
    },
  ];

  const finalResult = data
    ? data.filter((item) => {
        return [
          "hospitalName",
          "hospitalTelephone",
          "hospitalAdmissionDate",
          "hospitalDischargeDate",
          "hospitalDischargeDx",
          "locationDischargedTo",
          "dischargeInstructions",
          "medxNotes",
          "createdBy",
        ].some((key) =>
          (item[key]?.toString()?.toLowerCase() ?? "").includes(
            query?.toLowerCase() ?? ""
          )
        );
      })
    : data;

  if (isLoading) {
    return <Skeleton active={isLoading} />;
  }

  return (
    <>
      <div className="tw-flex tw-justify-between ">
        <p
          className="pt-3"
          style={{
            color: "#D2691E",
            fontWeight: "600",
          }}
        >
          Hospital Discharge Template
        </p>

        <div className="tw-flex tw-justify-end  tw-mt-3 ">
          <Space>
            <Search
              className=" tw-mb-4"
              size="middle"
              placeholder="Search"
              onChange={(e) => setQuery(e.target.value)}
              allowClear
            />
            <Button
              type="primary"
              onClick={() => setIsModalOpen(true)}
              className="tw-mb-4 "
            >
              Add
            </Button>
          </Space>
        </div>
      </div>
      {isModalOpen && (
        <Drawer
          open={isModalOpen}
          title={"Add/Update Hospital Discharge Template"}
          onClose={handleCancel}
          width={900}
        >
          <CareHospitalDischargeAdd
            callback={handleOk}
            editRecord={editRecord}
          />
        </Drawer>
      )}
      <Table
        bordered
        size="middle"
        dataSource={finalResult}
        columns={columns}
        virtual
        scroll={{
          x: 2000,
          y: 1000,
        }}
      />

      {mail && (
        <SendEmail
          open={mail}
          close={handleModalClose}
          editRecord={editRecord}
          modalTitle={"Hospital Discharge Template"}
          patientName={props?.patient?.label}
        />
      )}
    </>
  );
};

export default CareHospitalDischarge;
